import { type AxiosInstance, type AxiosError } from "axios";
import useSWR from "swr";
import type { KeyedMutator } from "swr";
import type { ParseResult } from "@/features/dmManagement/types";
import { swrErrorHandler } from "@/features/dmManagement/api/handleApiError";

interface IResponse {
  data: ParseResult | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<ParseResult>;
  error: AxiosError | undefined;
}

/**
 * 指定された発注の宛先リストデータを取得する。
 * @param apiClient - axios インスタンス
 * @param id - 発注ID
 * @param enabled - true の場合のみフェッチを実行する（デフォルト: true）
 * @returns 宛先リストのパース結果・ローディング状態・mutate関数・エラー
 */
export const GetAddressListDataAPI = (
  apiClient: AxiosInstance,
  id: number,
  enabled = true
): IResponse => {
  const fetcher = async (url: string): Promise<ParseResult> => {
    const { data } = await apiClient.get<ParseResult>(url);
    return data;
  };

  const { data, isLoading, mutate, error } = useSWR<ParseResult, AxiosError>(
    enabled ? [`/dm/orders/${id}/address-list/`] : null,
    async ([url]: [string]) => await fetcher(url),
    {
      revalidateOnFocus: false,
      onError: swrErrorHandler,
    }
  );

  return { data, isLoading, mutate, error };
};
